import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useHistory } from 'react-router';
import { unauthHeaders } from '../../utils/API';
import { ErrorAlert } from '../../utils/Alerts';
import Medcard from './Medcard';
import UserContext from '../../UserContext';

const MedcardContainer = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [mdocs, setMdocs] = useState([]);

    const [dateBegin, setDateBegin] = useState(moment().add(-1, 'year').format('YYYY-MM-DD'));
    const [dateEnd, setDateEnd] = useState(moment().add(1, 'days').format('YYYY-MM-DD'));
    const [selectedFilter, setSelectedFilter] = useState('Год');

    const userId = sessionStorage.getItem('userId');
    const {setCurrentMenuItem} = useContext(UserContext);

    const getDocs = () => {
        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_API}api/v1.0/profile/${userId}/mdocs?dateBegin=${dateBegin}&dateEnd=${dateEnd}`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsLoading(false);
                setMdocs(res.data);
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    const getResultPdf = (prescId, fileName) => {
        axios.get(`${process.env.REACT_APP_API}api/v1.0/profile/mdoc/result/pdf?PrescId=${prescId}`, {
            responseType: 'arraybuffer',
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
        })
            .then(response => {
                const type = response.headers['content-type'];
                const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${fileName}.pdf`;
                link.click();
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
            });
    }


    useEffect(() => {
        getDocs();
    }, [dateBegin, dateEnd])

    useEffect(() => {
        setCurrentMenuItem('medcard');
    }, []);

    const onChangeFilter = (e) => {
        setSelectedFilter(e.label);
        setDateBegin(e.dateStart);
        setDateEnd(e.dateEnd);
    }

    return (
        <>
            {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
            <Medcard
                isLoading={isLoading}
                mdocs={mdocs}
                selectedFilter={selectedFilter}
                onChangeFilter={onChangeFilter}
                getResultPdf={getResultPdf}
            />
        </>
    )
}

export default MedcardContainer;
